import {ErrorState} from "./index";
import {AnyAction} from "redux";

export const error = (state: ErrorState = {}, action: AnyAction) => {
  const {type, payload} = action;

  // Store BEGIN to clear messages when a new request is processed
  const matches = /(.*)_(BEGIN|FAILURE)/.exec(type);

  if (!matches) {
    return state;
  }

  const [, requestName, requestState] = matches;

  return {
    ...state,
    [requestName]: requestState === "FAILURE" ? action.payload.error : null
  }
}

export default error;
